export default function About({ lang, tAbout }) {
  if (!tAbout) return null;

  return (
    <section className="section about-section" id="onas">
      <div className="about-image-wrapper">
        <img
          src="/images/about-detail.jpeg"
          alt={
            lang === "pl"
              ? "Zbliżenie faktury ręcznie wykonanego obrazu tekstylnego"
              : "Close-up of the texture of a handmade textile artwork"
          }
          loading="lazy"
        />
      </div>

      <div className="about-content">
        <div className="section-header">
          <h2 className="section-title">{tAbout.title}</h2>
          <span className="section-subtitle">{tAbout.subtitle}</span>
        </div>

        <p className="about-body">{tAbout.body}</p>
      </div>
    </section>
  );
}
